<template>
  <v-container grid-list-md pt-3 pb-0>
    <v-layout row wrap>
      <v-btn
      color="primary"
      @click.stop="drawer = !drawer"
      style="position:absolute; z-index:1;top: 110px;"
      class="marginButton"
      >
      <v-icon class="mr-1">search</v-icon>
      ค้นหา
    </v-btn>
    <v-navigation-drawer
    absolute
    v-model="drawer"
    class="pl-2 pr-2 pt-2 marginMenu widthMenu"
    hide-overlay
    width="300"
    style="border-radius:2px !important; box-shadow: none !important"
    id="search-menu"
    >
    <v-container fluid fill-height pa-0>
      <v-layout column>
        <v-flex xs2 md2>
          <v-layout row wrap justify-space-between align-center pl-2 pr-2 pb-0 >
            <v-flex xs10 md10>
              <span class="button-font font-weight-bold mr-2"><v-icon class="mr-2">search</v-icon>ค้นหาเพิ่มเติม</span>
            </v-flex>
            <v-flex xs1>
              <v-icon @click.stop="drawer = !drawer">chevron_left</v-icon>
            </v-flex>
          </v-layout>
        </v-flex >
        <v-flex xs3 md3>
          <v-layout row wrap align-start >
            <v-flex xs12 sm12 md12 >
              <span class="button-font font-weight-bold mr-2">รูปแบบการแสดงผล: </span>
              <v-btn-toggle v-model="mapType" mandatory>
                <v-btn flat value="icon" class="button-font" @click="addMarkers('icon', listMarker)">
                  <span>ไอคอน</span>
                  <v-icon>place</v-icon>
                </v-btn>
                <v-btn flat value="image" class="button-font" @click="addMarkers('images', listMarker)">
                  <span>รูปภาพ</span>
                  <v-icon>photo</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
        </v-flex >
        <v-divider class="mt-2 mb-1"></v-divider>
        <v-flex xs4 md4>
          <v-layout row wrap fill-height mb-1>
            <v-flex xs12 sm12 md12 class="title font-weight-bold">ชนิดต้นไม้ที่ปลูกมาก 10 อันดับ</v-flex>
            <v-flex xs12 sm12 md12>
              <v-select
              v-model="plantTopTen"
              :items="listPlantTopTen"
              solo
              chips
              hide-details
              item-text="plant_name"
              item-value="plant_id"
              multiple
              color="blue"
              label="ต้นไม้ที่ปลูกมาก 10 อันดับ"
              dense
              id="search1"
              >
              <template v-slot:selection="data" id="plantTopTen2">
                <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="remove(data.item)"
                >
                <v-avatar>
                  <img :src="data.item.icon">
                </v-avatar>
                {{ data.item.plant_name }}
              </v-chip>
            </template>
            <template v-slot:item="data" id="3">
              <template>
                <v-list-tile-avatar>
                  <v-img :src="data.item.icon" aspect-ratio="1"></v-img>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.plant_name + ' ' + commaSeparateNumber(data.item.sumPlant) + ' ต้น'"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-divider class="mt-1 mb-1"></v-divider>
    <v-flex xs6 md6>
      <v-layout row wrap pb-0>
        <v-flex xs12 sm12 md12 class="title font-weight-bold">เพิ่มข้อกำหนดการแสดงผลโดยวันที่</v-flex>
        <v-flex xs12 sm12 md12>
          <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          color="blue"
          hide-details
          >
          <template v-slot:activator="{ on }">
            <v-text-field
            v-model="startDateFormatted"
            readonly
            prepend-inner-icon="event"
            label="วันเริ่มต้น"
            solo
            hide-details
            v-on="on"
            color="blue"
            @blur="startDate = parseDate(startDateFormatted)"
            required
            ></v-text-field>
          </template>
          <v-date-picker locale="th" v-model="startDate" no-title @input="menu = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 md12>
        <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
        color="blue"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
          v-model="endDateFormatted"
          readonly
          prepend-inner-icon="event"
          label="วันสิ้นสุด"
          solo
          hide-details
          v-on="on"
          color="blue"
          @blur="endDate = parseDate(endDateFormatted)"
          required
          :disabled="startDate !== ''  && startDate !== null ? false : true"
          ></v-text-field>
        </template>
        <v-date-picker :min="startDate" locale="th" v-model="endDate" no-title @input="menu2 = false"></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs12 md12 class="pb-0">
      <span class="font-weight-bold red--text" style="font-size:17px !important">*การเลือกช่วงระยะเวลาที่ยาวนาน จะทำให้แสดงผลช้า</span>
    </v-flex>
  </v-layout>
</v-flex>
<v-flex xs12 md12>
  <!-- <v-layout> -->
    <v-flex xs12 sm12 md12 class="pt-0 pb-0" style="height: 100% !important; align-items:flex-end; display: flex; justify-content: center;">
      <div class="" style="border-top:1px solid rgba(0,0,0,0.12);width:100%; text-align:center">
        <v-btn round color="primary" @click="queryUserPlantMarkersWithSearch()">ค้นหา</v-btn>
        <v-btn round color="" @click="queryUserPlantMarkers()">ล้างค่าทั้งหมด</v-btn>
      </div>
    </v-flex>
  <!-- </v-layout> -->
</v-flex>
</v-layout>
</v-container>
</v-navigation-drawer>
<v-layout row wrap >
  <v-flex xs12 md12 style="position:relative; padding: 0 !important;">
    <v-container grid-list-md class="modal_loading" v-if="loading_save">
      <v-progress-circular
      indeterminate
      color="primary"
      ></v-progress-circular>
    </v-container>
    <div id="overview-map">
    </div>
  </v-flex>
</v-layout>

</v-layout>
</v-container>
</template>

<script>
/* global google */
import Vue from 'vue'
var _ = require('lodash')
import ComponentMapInfowindow from '@/components/ComponentMapInfowindow'
import { loadGMapsAPI } from '@/utils/gmaps'
import { createURL } from '@/utils/common'
export default {
  components: {
    /* eslint-disable vue/no-unused-components */
    ComponentMapInfowindow
  },
  data() {
    return {
      resizeWatcher: false,
      mapType: "icon",
      startDate: '',
      endDate: '',
      menu: false,
      menu2: false,
      startDateFormatted: '',
      endDateFormatted: '',
      disabled: true,
      listMarker: [],
      markers: [],
      listPlantTopTen: [],
      plantTopTen: [],
      loading_save: false,
      srcs : [
        {"icon": require('../assets/images/icon-tree/tree-icon1.png')},
        {"icon": require('../assets/images/icon-tree/tree-icon2.png')},
        {"icon": require('../assets/images/icon-tree/tree-icon3.png')},
        {"icon": require('../assets/images/icon-tree/tree-icon4.png')},
        {"icon": require('../assets/images/icon-tree/tree-icon5.png')},
        {"icon": require('../assets/images/icon-tree/tree-icon6.png')},
        {"icon": require('../assets/images/icon-tree/tree-icon7.png')},
        {"icon": require('../assets/images/icon-tree/tree-icon8.png')},
        {"icon": require('../assets/images/icon-tree/tree-icon9.png')},
        {"icon": require('../assets/images/icon-tree/tree-icon10.png')}
      ],
      drawer: null,
    }
  },
  created(){
    this.queryPlantTopTen()
    // console.log(this.$route.path.split('/'));
    this.$emit('activeMenu', 'map')
  },
  mounted() {
    loadGMapsAPI.then(this.initMap) // make initMap a global function for Google Maps to callback

  },
  watch:{
    startDate () {
      // console.log(this.startDate);
      this.startDateFormatted = this.formatDate(this.startDate)
    },
    endDate () {
      this.endDateFormatted = this.formatDate(this.endDate)
    }
  },
  methods: {
    // initMap() { // do not call this method directly
    //   /* create map */
    //   const bangkokCenter = { lat: 13.736717, lng: 100.523186 }
    //   const mapElement = document.getElementById('overview-map')
    //   this.map = new google.maps.Map(mapElement, { zoom: 6, center: bangkokCenter })
    //
    //   /* create layers */
    //   this.mapLayers = new google.maps.MVCObject()
    //   this.mapLayers.setValues({ iconLayer: this.map, imageLayer: null }) // defaults to icon layer
    //
    //   /* toggle to default layer */
    //   this.toggleMapType(this.mapType)
    //
    //   this.axios.post(createURL('queryUserPlantMarkers'))
    //
    //     .then(response => {
    //       this.addMarkers(response.data)
    //     })
    // },
    // addMarkers(infoArray) {
    //   console.log(infoArray);
    //
    //   /* context is a reference to this component. used inside event listeners */
    //   const context = this
    //
    //   /* create a class for populating infowindow  */
    //   const InfowindowClass = Vue.extend(ComponentMapInfowindow)
    //
    //   /* custom marker icon */
    //   const customMarkerIcon = {
    //     url: require('../assets/images/tree-icon.png'),
    //     anchor: new google.maps.Point(13, 42),
    //     scaledSize: new google.maps.Size(27, 43)
    //   }
    //
    //   /* custom marker icon for royal trees */
    //   const customMarkerIconRoyal = {
    //     url: require('../assets/images/tree-icon-gold.png'),
    //     anchor: new google.maps.Point(13, 42),
    //     scaledSize: new google.maps.Size(27, 43)
    //   }
    //
    //   let countByProvinceId = {}
    //
    //   for (const info of infoArray) {
    //     /* count markers by province id */
    //     if (info.provinceId != undefined) {
    //       if (!(info.provinceId in countByProvinceId)) {
    //         countByProvinceId[info.provinceId] = 1
    //       } else {
    //         countByProvinceId[info.provinceId] += 1
    //       }
    //     }
    //
    //     const isRoyalTree = (info.options && info.options.royalTree)
    //     const iconToUse = isRoyalTree ? customMarkerIconRoyal : customMarkerIcon
    //
    //     let infowindowContent = new InfowindowClass({
    //       propsData: {
    //         royalTree: (info.options && info.options.royalTree),
    //         imageUrl: createURL(info.thumbMedium)
    //       }
    //     })
    //     infowindowContent.$mount()
    //     const markerPosition = { lat: info.lat, lng: info.lng }
    //     const infowindow = new google.maps.InfoWindow({ content: infowindowContent.$el })
    //
    //     /* add markers to icon layer */
    //     const iconMarker = new google.maps.Marker({
    //       position: markerPosition,
    //       icon: iconToUse,
    //       map: this.map
    //     })
    //     iconMarker.addListener('click', function() {
    //       infowindow.open(context.map, iconMarker)
    //       if (context.previousInfowindow) {
    //         context.previousInfowindow.close()
    //       }
    //       context.previousInfowindow = infowindow
    //     })
    //
    //     // iconMarker.bindTo('map', this.mapLayers, 'iconLayer')
    //     // console.log(this.mapLayers);
    //
    //     /* add markers to image layer (limit to 10 markers per province) */
    //     if (countByProvinceId[info.provinceId] <= 10) {
    //       const imageMarkerIcon = {
    //         url: createURL(info.thumbSmall),
    //         anchor: new google.maps.Point(25, 25),
    //         scaledSize: new google.maps.Size(50, 50)
    //       }
    //       const imageMarker = new google.maps.Marker({
    //         position: markerPosition,
    //         icon: imageMarkerIcon,
    //         map: this.map
    //       })
    //       imageMarker.addListener('click', function() {
    //         infowindow.open(context.map, imageMarker)
    //         if (context.previousInfowindow) {
    //           context.previousInfowindow.close()
    //         }
    //         context.previousInfowindow = infowindow
    //       })
    //       // imageMarker.bindTo('map', this.mapLayers, 'imageLayer')
    //       console.log(this.mapLayers);
    //       // this.mapLayers.setValues({ iconLayer: this.map, imageLayer: null })
    //     }
    //   }
    // },
    // toggleMapType(type) {
    //   if (type == 'icon') {
    //     this.mapLayers.set('iconLayer', this.map) // Show icon map
    //     this.mapLayers.set('imageLayer', null) // Hide image map
    //   }
    //   else if (type == 'image') {
    //     this.mapLayers.set('iconLayer', null) // Hide icon map
    //     this.mapLayers.set('imageLayer', this.map) // Show image map
    //   }
    // },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      var year_thai = parseInt(year) + 543
      return `${day}/${month}/${year_thai}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      var year_2 = parseInt(year) - 543
      return `${year_2}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    remove (item) {
      const index = this.plantTopTen.indexOf(item.plant_id)
      if (index >= 0){
        this.plantTopTen.splice(index, 1)
      }
    },
    commaSeparateNumber(val){
      while (/(\d+)(\d{3})/.test(val.toString())){
        val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
      return val;
    },
    queryPlantTopTen(){
      this.axios.post(process.env.VUE_APP_IPFLASK + '/queryPlantTopTen').then((response) => {
        // console.log(response.data);
        this.listPlantTopTen = response.data
        for (var i = 0; i < this.listPlantTopTen.length; i++) {
          _.merge(this.listPlantTopTen[i], this.srcs[i]);
        }
        // console.log(this.listPlantTopTen);
      })
    },
    queryUserPlantMarkersWithSearch(){
      if (this.$vuetify.breakpoint.name === 'sm' || this.$vuetify.breakpoint.name === 'xs') {
        this.drawer = false
      }
      this.loading_save = true
      // console.log(this.plantTopTen);
      if (this.startDate !== '' && this.startDate !== null && this.endDate === '') {
        this.$swal('กรุณาเลือกวันสิ้นสุด','','error')
        this.loading_save = false
        return
      }
      if (this.startDate == null) {
        this.startDate = ''
      }
      this.axios.post(process.env.VUE_APP_IPFLASK + '/queryUserPlantMarkersWithSearch', {startDate: this.startDate, endDate: this.endDate, plantTopTen : this.plantTopTen}).then((response) => {
        this.listMarker = response.data
        if(this.plantTopTen.length !== 0){
          _.each(this.listMarker, listMarker => {
            const { icon } = _.find(this.listPlantTopTen, {'plant_id': listMarker.plant_id})
            this.$set(listMarker, 'icon', icon)
          })
        }
        this.deleteMarkers()
        this.mapType = 'icon'
        this.addMarkers('icon', this.listMarker)
        // console.log(this.listMarker);
      })
    },
    queryUserPlantMarkers(){
      this.loading_save = true
      this.startDate = ''
      this.endDate = ''
      this.plantTopTen = []
      this.axios.post(process.env.VUE_APP_IPFLASK + '/queryUserPlantMarkers').then((response) => {
        this.listMarker = response.data
        this.mapType = 'icon'
        this.addMarkers('icon',this.listMarker)
      })
    },
    deleteMarkers() {
      this.clearMarkers();
      // console.log('delete');
      this.markers = [];
    },
    clearMarkers() {
      this.setMapOnAll(null)
    },
    openMenu(){
      this.drawer = true
    },
    setMapOnAll(map) {
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(map);
      }
      // console.log('setMapOnAll');
    },
    initMap() {
      var bangkokCenter = { lat: 13.736717, lng: 100.523186 }
      this.map = new google.maps.Map(document.getElementById('overview-map'), {
        zoom: 5.6,
        center: bangkokCenter,
        mapTypeControl: true,
      });
      this.queryUserPlantMarkers()


      // var centerControlDiv = document.createElement('div');
      // var centerControl = this.centerControl(centerControlDiv, this.map);
      //
      // centerControlDiv.index = 1;
      // this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(centerControlDiv);
      // this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(document.getElementById("search-menu"))
      // this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementsByClassName("menu"))
      // this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(document.getElementByClassName("v-menu__content"))


    },
    // centerControl(controlDiv, map){
    //   // Set CSS for the control border.
    //     var controlUI = document.createElement('div');
    //     controlUI.style.backgroundColor = '#FFE248';
    //     controlUI.style.width = '100px';
    //     controlUI.style.borderRadius = '3px';
    //     controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
    //     controlUI.style.cursor = 'pointer';
    //     controlUI.style.marginBottom = '22px';
    //     controlUI.style.marginLeft = '10px';
    //     controlUI.style.textAlign = 'center';
    //     controlUI.title = 'ค้นหา';
    //     controlDiv.appendChild(controlUI);
    //
    //     // Set CSS for the control interior.
    //     var controlText = document.createElement('div');
    //     controlText.style.color = 'rgb(25,25,25)';
    //     controlText.style.fontSize = '20px';
    //     controlText.style.fontWeight = '700';
    //     controlText.style.lineHeight = '38px';
    //     controlText.style.paddingLeft = '5px';
    //     controlText.style.paddingRight = '5px';
    //     controlText.innerHTML = '<i id="icon" class="material-icons">search</i>' + '<span>ค้นหา</span>';
    //     controlUI.appendChild(controlText);
    //
    //     controlUI.addEventListener('click', () => {
    //       var me = this
    //       console.log(me.drawer);
    //       me.drawer = true
    //     });
    //
    //     return controlUI
    // },
    addMarkers(type,locations) {
      this.loading_save = true
      this.deleteMarkers()
      if(type === 'icon'){
        const customMarkerIcon = {
          url: require('../assets/images/tree-icon.png'),
          anchor: new google.maps.Point(13, 42),
          scaledSize: new google.maps.Size(27, 43)
        }

        /* custom marker icon for royal trees */
        const customMarkerIconRoyal = {
          url: require('../assets/images/tree-icon-gold.png'),
          anchor: new google.maps.Point(13, 42),
          scaledSize: new google.maps.Size(27, 43)
        }
        locations.forEach((location) => {

          // console.log(location);
          const isRoyalTree = (location.options && location.options.royalTree)
          // const iconToUse = isRoyalTree ? customMarkerIconRoyal : customMarkerIcon
          var iconToUse = ''
          // console.log(location.icon);
          if (location.icon !== undefined) {
            if (isRoyalTree) {
              iconToUse =  {
                url: require('../assets/images/tree-icon-gold.png'),
                anchor: new google.maps.Point(13, 42),
                scaledSize: new google.maps.Size(27, 43)
              }
            } else {
              iconToUse =  {
                url: location.icon,
                anchor: new google.maps.Point(13, 42),
                scaledSize: new google.maps.Size(27, 43)
              }
            }
          } else if(isRoyalTree) {
            iconToUse = customMarkerIconRoyal
          } else {
            iconToUse = customMarkerIcon
          }
          var marker = new google.maps.Marker({
            position: { lat: location.lat, lng: location.lng },
            map: this.map,
            icon: iconToUse
          });
          // console.log(marker.icon);
          this.markers.push(marker);

          // info window
          const context = this
          /* create a class for populating infowindow  */
          const InfowindowClass = Vue.extend(ComponentMapInfowindow)

          let infowindowContent = new InfowindowClass({
            propsData: {
              royalTree: (location.options && location.options.royalTree),
              imageUrl: createURL(location.thumbMedium)
            }
          })
          infowindowContent.$mount()
          const infowindow = new google.maps.InfoWindow({ content: infowindowContent.$el })

          marker.addListener('click', function() {
            if (context.previousInfowindow) {
              context.previousInfowindow.close()
            }
            infowindow.open(context.map, marker)
            context.previousInfowindow = infowindow
          })
        })
      } else {
        this.deleteMarkers()
        locations.forEach((location) => {
          const imageMarkerIcon = {
            url: createURL(location.thumbSmall),
            anchor: new google.maps.Point(25, 25),
            scaledSize: new google.maps.Size(50, 50)
          }
          const marker = new google.maps.Marker({
            position: { lat: location.lat, lng: location.lng },
            icon: imageMarkerIcon,
            map: this.map
          })
          this.markers.push(marker);

          const context = this
          const InfowindowClass = Vue.extend(ComponentMapInfowindow)

          let infowindowContent = new InfowindowClass({
            propsData: {
              royalTree: (location.options && location.options.royalTree),
              imageUrl: createURL(location.thumbMedium)
            }
          })
          infowindowContent.$mount()
          const infowindow = new google.maps.InfoWindow({ content: infowindowContent.$el })

          marker.addListener('click', function() {
            if (context.previousInfowindow) {
              context.previousInfowindow.close()
            }
            infowindow.open(context.map, marker)
            context.previousInfowindow = infowindow
          })
        })
      }
      this.loading_save = false
    }
  }
}
</script>

<style scoped>
#overview-map {
  height: calc(100vh - 215px);  /* The height is 400 pixels */
  width: 100%;  /* The width is the width of the web page */
}
.button-font{
  font-size: 20px;
}
.modal_loading{
  position: absolute;
  background: #4e4e4e70;
  z-index: 4;
  left: 0;
  height: calc(100vh - 215px);
  align-items: center;
  justify-content: center;
  display: flex;
}



@media only screen and (max-width: 320px){
  .marginMenu{
    top: 18px !important;
    left: 15px !important;
  }
  .widthMenu{
    width:260px !important;
    height: calc(100vh - 230px) !important;
  }
  .marginButton{
    left:15px;
  }
}

@media only screen and (min-width: 321px) and (max-width: 600px){
  .marginMenu{
    top: 18px !important;
    left: 15px !important;
  }
  .widthMenu{
    width:290px !important;
    height: calc(100vh - 230px) !important;
  }
  .marginButton{
    left:15px;
  }

}

@media only screen and (min-width: 601px) and (max-width: 960px){
  .marginMenu{
    top: 90px !important;
    left: 20px !important;
  }
  .widthMenu{
    width:300px !important;
    height: calc(100vh - 300px) !important;
  }
  .marginButton{
    left:16px;
  }
}

@media only screen and (min-width: 961px){
  .marginMenu{
    top: 80px !important;
    left: 22px !important;
  }
  .widthMenu{
    width:300px !important;
    height: calc(100vh - 290px) !important;
  }
  .marginButton{
    left:18px;
  }
}

.v-navigation-drawer--close {
  transform: translateX(-400px) !important;
}
</style>
